module.exports = __webpack_public_path__ + "static/media/logo.af01edc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 782
// module chunks = 0